import React from 'react';
import PropTypes from 'prop-types';
import { createVariants } from './_variants';

const badgeClasses = createVariants({
  base: 'inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium transition-theme duration-theme',
  variants: {
    primary: 'bg-succession-primary-light text-succession-primary',
    secondary: 'bg-succession-secondary-light text-succession-secondary',
    accent: 'bg-succession-accent-light text-succession-accent',
    success: 'bg-green-100 text-green-800',
    warning: 'bg-amber-100 text-amber-800',
    error: 'bg-red-100 text-red-800',
    info: 'bg-blue-100 text-blue-800',
    neutral: 'bg-succession-bg-tertiary text-succession-text-secondary',
  },
  sizes: {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-3 py-1',
    lg: 'text-base px-4 py-1.5',
  },
  defaultVariant: 'neutral',
  defaultSize: 'md',
});

const Badge = ({ variant = 'neutral', size = 'md', icon, children, className, ...rest }) => {
  const classes = badgeClasses({ variant, size, className });
  
  return (
    <span className={classes} {...rest}>
      {icon && <span className="flex-shrink-0">{icon}</span>}
      {children}
    </span>
  );
};

Badge.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'accent', 'success', 'warning', 'error', 'info', 'neutral']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  icon: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Badge;

